var map = {
	"./about/CharlesThomas01.jpg": 34,
	"./about/CharlesThomas02.jpg": 35,
	"./about/CharlesThomas03.jpg": 36,
	"./about/CharlesThomas04.jpg": 37,
	"./about/Dilo01.jpg": 38,
	"./about/Dilo02.jpg": 39,
	"./about/Dilo03.jpg": 40,
	"./about/Dilo04.jpg": 41,
	"./about/Dilo05.jpg": 42,
	"./ambassadors/ahmad.jpg": 43,
	"./ambassadors/tako.jpg": 44,
	"./contact/flag-angola.jpg": 20,
	"./contact/flag-uk.jpg": 21,
	"./ethics/ethics.jpg": 24,
	"./ethics/qhse.jpg": 25,
	"./home/heroImage.jpg": 45,
	"./logo/StripedHorseResources_Logo2000x2000.png": 84,
	"./logo/StripedHorseResources_LogoSML.png": 28,
	"./partners/EMGS.png": 85,
	"./partners/Geode.jpg": 46,
	"./partners/NVentures.jpg": 47,
	"./partners/PVE.png": 86,
	"./partners/PromoteEnergy.jpg": 48,
	"./partners/Risk-BasedSolutions.jpg": 49,
	"./partners/Risk-BasedSolutions.psd": 87,
	"./partners/Rockwash.png": 88,
	"./partners/Tsavo.png": 89,
	"./placeholder.jpeg": 90,
	"./services/serviceA.jpg": 50,
	"./services/serviceB.jpg": 51,
	"./services/serviceC.jpg": 52,
	"./services/serviceD.jpg": 53,
	"./services/serviceE.jpg": 54,
	"./services/serviceF.jpg": 55,
	"./services/serviceG.jpg": 56,
	"./services/serviceH.jpg": 57,
	"./services/serviceI-old.jpg": 58,
	"./services/serviceI.jpg": 59,
	"./services/serviceJ.jpg": 60,
	"./source/Striped Horse QHSE Policy.pdf": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;